/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Position } from './Position';
import {
    PositionFromJSON,
    PositionFromJSONTyped,
    PositionToJSON,
} from './Position';

/**
 * 
 * @export
 * @interface PositionPage
 */
export interface PositionPage {
    /**
     * 
     * @type {Array<Position>}
     * @memberof PositionPage
     */
    positions: Array<Position>;
    /**
     * 
     * @type {number}
     * @memberof PositionPage
     */
    totalNr: number;
    /**
     * 
     * @type {string}
     * @memberof PositionPage
     */
    asOfDate: string;
}

/**
 * Check if a given object implements the PositionPage interface.
 */
export function instanceOfPositionPage(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "positions" in value;
    isInstance = isInstance && "totalNr" in value;
    isInstance = isInstance && "asOfDate" in value;

    return isInstance;
}

export function PositionPageFromJSON(json: any): PositionPage {
    return PositionPageFromJSONTyped(json, false);
}

export function PositionPageFromJSONTyped(json: any, ignoreDiscriminator: boolean): PositionPage {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'positions': ((json['positions'] as Array<any>).map(PositionFromJSON)),
        'totalNr': json['total_nr'],
        'asOfDate': json['as_of_date'],
    };
}

export function PositionPageToJSON(value?: PositionPage | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'positions': ((value.positions as Array<any>).map(PositionToJSON)),
        'total_nr': value.totalNr,
        'as_of_date': value.asOfDate,
    };
}

